import PropTypes from 'prop-types';
import s from './NavigationHeader.module.css';
import { SearchForm } from 'components/NavigationHeader/SearchForm/SearchForm';
import {
  LinkToLikes,
  LinkToFavorites,
  LinkToDislikes,
} from 'components/NavigationHeader/LinkButton/LinkButton';
import { fetchBreedByName } from 'services/API/API';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import addQuery from '../../redux/cats-actions';

const NavigationHeader = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const distpatch = useDispatch();

  const queryHandler = query => {
    fetchBreedByName(query).then(data => {
      if (data.length) {
        const [{ id: breedId }] = data;
        distpatch(addQuery(breedId));
        navigate('/search', {
          state: { path: pathname },
        });
      } else {
        navigate('/search', {
          state: { path: pathname },
        });
      }
    });
  };

  return (
    <div className={s.navigation_header}>
      <div className={s.searchBar}>
        <SearchForm onSearch={queryHandler} />
      </div>

      <div className={s.linksToPages}>
        <LinkToLikes />
        <LinkToFavorites />
        <LinkToDislikes />
      </div>
    </div>
  );
};

export { NavigationHeader };

NavigationHeader.propTypes = { onSearch: PropTypes.func };
